import React from 'react'
import MultipleInputsFilter from './MultipleInputsFilter'
import OdsPgFilter from './OdsPgFilter'
import { ConfigFiltersLayoutProps } from '../types'

const ConfigFiltersDesktop = ({ chainColumns, independentColumns }: ConfigFiltersLayoutProps) => {
    return (
        <>
            <MultipleInputsFilter columns={chainColumns} />
            <OdsPgFilter columns={independentColumns} />
        </>
    )
}

export default ConfigFiltersDesktop
